import React, { useState, useRef, useEffect } from 'react';
import Api from "../../../services/api.js";
import PaginationComponent from "../../../components/pagination";
import { toast } from "react-toastify";
import { Modal } from 'react-bootstrap';
import LoadingComponent from "../../../components/loading";
import { useParams } from "react-router-dom";

function DataConnectors() {
    const [show, setShow] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const { code, os } = useParams();

    const [filterName, setFilterName] = useState('');
    const [showFilterPopup, setShowFilterPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [sortOrder, setSortOrder] = useState(null); // 'asc', 'desc', or null

    const filterIconRef = useRef(null);
    const filterPopupRef = useRef(null);

    const handleChangePage = (page) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        const searchParams = {};

        if (filterName) {
            searchParams.name = filterName;
        }

        if (sortOrder) {
            searchParams.sort_by = 'name';
            searchParams.sort_order = sortOrder;
        }

        fetchData(searchParams);
    }, [currentPage, sortOrder, code, os]);

    const fetchData = (params) => {
        setLoading(true);
        const finalParams = {
            code: code,
            os: os,
            page: currentPage,
            ...params
        };

        Api.get(`api/app/data_connector?os=${os}&code=${code}&sort_by_column=${finalParams?.sort_by || ''}&sort_value_by=${finalParams?.sort_order || ''}&name=${finalParams?.name || ''}&page=${currentPage}`)

            .then(result => {
                console.log('result', result)
                if (result && result.data && result.data.code === 0) {
                    setData(result.data.data);
                    setTotalPage(result.data.total_page);
                } else {
                    toast.error(result.data.message || "Lỗi khi lấy dữ liệu !!");
                    setData([]);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
                toast.error("Không thể kết nối đến server hoặc API bị lỗi.");
                setLoading(false);
            });
    };

    const handleDelete = (id) => {
        if (!window.confirm("Bạn có chắc muốn xoá connector này không?")) return;

        setLoading(true);

        Api.post(`/api/app/data_connector/update_status`, {
            id: id,
            code: code,
            os: os
        })
            .then((res) => {
                if (res.data.code === 0) {
                    toast.success("Đã chuyển trạng thái thành 'deleted'");
                    fetchData();
                } else {
                    toast.error("Không cập nhật được trạng thái");
                }
            })
            .catch(() => toast.error("Lỗi khi cập nhật trạng thái"))
            .finally(() => setLoading(false));
    };

    const handleClickFilter = () => {
        if (filterIconRef.current) {
            const rect = filterIconRef.current.getBoundingClientRect();
            const popupWidth = 200; // chiều rộng thực của popup (px)

            setPopupPosition({
                top: rect.bottom + window.scrollY, // ngay dưới icon
                left: rect.right - popupWidth + window.scrollX // canh phải icon
            });
        }
        setShowFilterPopup(!showFilterPopup);
    };

    const handleFilterSubmit = () => {
        setCurrentPage(1);

        const params = {};
        if (filterName) params.name = filterName;
        if (sortOrder) {
            params.sort_by = 'name';
            params.sort_order = sortOrder;
        }

        fetchData(params);
        setShowFilterPopup(false);
    };

    const handleClosePopup = () => {
        setShowFilterPopup(false);
    };

    const handleClickSort = () => {
        if (sortOrder === null) {
            setSortOrder('asc');
        } else if (sortOrder === 'asc') {
            setSortOrder('desc');
        } else {
            setSortOrder(null);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                filterIconRef.current &&
                !filterIconRef.current.contains(event.target) &&
                filterPopupRef.current &&
                !filterPopupRef.current.contains(event.target)
            ) {
                setShowFilterPopup(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const getSortIconClass = () => {
        if (sortOrder === 'asc') return 'fa-sort-up text-primary';
        if (sortOrder === 'desc') return 'fa-sort-down text-primary';
        return 'fa-sort';
    };

    return (
        <>
            {/* Removed main__filter section as requested */}

            <section className="main__content">
                <div className="container-fluid">
                    <div className="detail-body">
                        <div className="overview_content pd-20">
                            {/*<div className="mb-4">*/}
                            {/*    <div className="row">*/}
                            {/*        <div className="col-md-12">*/}
                            {/*            <div className="title-head-box">*/}
                            {/*                <p className="title-block">Data Connectors</p>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            <div className="mb-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="box box--chart" style={{ marginBottom: "10px" }}>
                                            <div className="box__content custom-table">
                                                <LoadingComponent loading={loading} />
                                                <div className="table-responsive" style={{ position: 'relative' }}>
                                                    <table className="table m-0 table--text-bold">
                                                        <thead>
                                                        <tr className="border-bt">
                                                            <th style={{ position: 'relative' }} className="d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    Connector
                                                                </div>

                                                                <div style={{ marginRight: "20px" }}>
                                                                    <i
                                                                        className={`fa fa-filter ms-2 ${showFilterPopup ? 'text-primary' : ''}`}
                                                                        ref={filterIconRef}
                                                                        onClick={handleClickFilter}
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                    <i
                                                                        className={`fa ms-2 ${getSortIconClass()}`}
                                                                        onClick={handleClickSort}
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                </div>
                                                            </th>
                                                            {/*<th>Status</th>*/}
                                                            {/*<th>Action</th>*/}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {data.length > 0 ? (
                                                            data.map((item) => (
                                                                <tr key={item.id} className="hover:bg-gray-100 align-middle">
                                                                    <td>
                                                                        {item.icon && (
                                                                            <img
                                                                                src={item.icon}
                                                                                alt={item.name}
                                                                                className="me-2"
                                                                                style={{
                                                                                    width: '30px',
                                                                                    height: '30px',
                                                                                    verticalAlign: 'middle'
                                                                                }}
                                                                            />
                                                                        )}
                                                                        <b>{item.name}</b>
                                                                        <p style={{ fontStyle: "italic" }}>{item.sub_name} - {item.app_name} - {item.os} - {item.app_store_id}</p>
                                                                    </td>
                                                                    {/*<td className="align-middle">{item.status}</td>*/}
                                                                    {/*<td className="align-middle">*/}
                                                                    {/*    <button*/}
                                                                    {/*        className="btn p-0 border-0 text-danger"*/}
                                                                    {/*        onClick={() => handleDelete(item.id)}*/}
                                                                    {/*        title="Xóa"*/}
                                                                    {/*    >*/}
                                                                    {/*        <i style={{ color: "red" }} className='fa-solid fa-trash'></i>*/}
                                                                    {/*    </button>*/}
                                                                    {/*</td>*/}
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="1" className="border border-gray-300 px-4 py-2 text-center">
                                                                    No data available
                                                                </td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <PaginationComponent
                                            current={currentPage}
                                            total={totalPage}
                                            handleChangePage={handleChangePage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {showFilterPopup && (
                        <div
                            className="filter-popup"
                            ref={filterPopupRef}
                            style={{
                                position: 'absolute',
                                top: popupPosition.top + 5,
                                left: popupPosition.left,
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '8px',
                                zIndex: 999,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                minWidth: '250px'
                            }}
                        >
                            <input
                                type="text"
                                placeholder="Connector name"
                                className="form-control mb-2"
                                value={filterName}
                                onChange={(e) => setFilterName(e.target.value)}
                            />
                            <div className="d-flex justify-content-end gap-2">
                                <button className="btn btn-sm btn-secondary" onClick={handleClosePopup}>Close</button>
                                <button className="btn btn-sm btn-primary" onClick={handleFilterSubmit}>Apply</button>
                            </div>
                        </div>
                    )}

                    <Modal show={show} onHide={() => setShow(false)}>
                        <Modal.Header>
                            <h5 className="modal-title">Modal title</h5>
                            <button type="button" className="close" onClick={() => setShow(false)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body>
                            <p>URL to your app on App Store / PlayStore</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>Close</button>
                            <button type="button" className="btn btn-primary">Save changes</button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </section>
        </>
    );
}

export default DataConnectors;